import {
  isAndroid,
  isQQBrowser
} from './UA'
import { CHECK_API, APP_INFO } from './constant'
import { get } from 'lodash'

export const isBaiPai = function () {
  const href = window.location.href || '';
  return (isAndroid(window.navigator.userAgent) && isQQBrowser(window.navigator.userAgent) && /source=baipai/.test(href)) || false; // 白牌合作商拉新统计
}

export const isWxDownload = function () {
    return window.SQB && window.SQB.Detect && window.SQB.Detect.isWX && window.SQB.Detect.isAndroid && window.SQB.wxDownload
}

export const detectStatus = async function (name = 'qb') {
  return new Promise(resolve => {
    console.log('CHECK_API[name]', CHECK_API[name])
    const isInstall = get(window, CHECK_API[name]);
    if (isInstall && typeof isInstall === 'function') {
      isInstall((data) => {
        resolve(data);
      });
    } else {
      resolve(false);
    }
  })
}

/**
 * 
 * @desc 检查本地应用安装状态，数据上报使用
 * @param {string} [name='qb']
 * @returns
 */
export const localAppStatus = async function (name = 'qb') {
  const [isInstallKb, isInstallQb] = await Promise.all([
    detectStatus('kb'),
    detectStatus('qb')
  ])

  return `qb=${isInstallQb ? 1 : 2}&kb=${isInstallKb ? 1 : 2}`
}

export const wxDownloadApi = async function ({name = 'qb'}) {
  // 拉新
  const appInfo = APP_INFO[name]
  const options = {
    taskName: appInfo.taskName,
    apkUrl: appInfo.downloadUrlNotTBS,
    apkMd5: '',
    logo: appInfo.logo,
  };
  window.SQB.wxDownload(options)
}

//安卓微信TBS/非TBS调下载中间页api
export const wxDownloadTask = async function ({name = 'qb'}) {
  const appInfo = APP_INFO[name]
  const options = {
    task_name:appInfo.taskName,
    task_url:appInfo.downloadUrlNotTBS,
    title:appInfo.appName,
    thumb_url:appInfo.logo,
    package_name:appInfo.pkgName,
    developer:appInfo.developer,
    privacy_agreement_url:appInfo.privacyAgreementUrl,
    permission_url:appInfo.permissionUrl,
  }
  if(name=== 'qb'){
    window.fetch('https://appchannel.html5.qq.com/package?app=qqbrowser').then(r => {r.text().then(res => {
      const versionInfo = JSON.parse(res)
      console.log('versionInfo', versionInfo)
      try {
          const url = versionInfo.downurl.split("qqbrowser_")[1].split('_')
          const time = versionInfo.downurl.split("GA_")[1].split("_")[0]
          const updateTime = `${time.substring(0,4)}/${time.substring(4,6)}/${time.substring(6,8)}`
          const version = url[0].substring(0, url[0].lastIndexOf('.'))
          options.app_version = version
          window.SQB.wxAddDownloadTask(options)
      } catch (e) {
          window.SQB.wxAddDownloadTask(options)
      }
    })})
  }else{
    options.app_version = "12.2.0"
    window.SQB.wxAddDownloadTask(options)
  }
}

export const baiPaiDownloadApi = function ({ url, statData = {} }) {
  // 白牌浏览器
  if (isBaiPai()) {
    // 拉活
    const runApk = get(window, 'browser.app.runApk');
    const showAlertDialog = get(window, 'browser.app.showAlertDialog');
    const copy = get(window, 'browser.device.copy') || false;
    if (runApk && showAlertDialog) {
      const showCallback = () => {
        showAlertDialog((res) => {
          if (res && res.result === 1) {
            runApk('com.tencent.mtt');
          } else if (res && res.result === 0) {
            console.log('取消');
          } else {
            console.log('参数错误');
          }
        }, {
          title: '',
          content: '请打开QQ浏览器地址框点击粘贴',
          cancel: '取消',
          confirm: '确定'
        });
      };
      if (copy) {
        copy(url, (res) => {
          setTimeout(() => {
            showCallback();
          }, 1300);
        });
      } else {
        showCallback();
      }
      return;
    }

    // 拉新
    const href = window.location.href 
    if (/&ch=/.test(href) || /\?ch=/.test(href)) {
      const jsDownload = get(window, 'browser.download');
      if (jsDownload && jsDownload.getDownloadStatus && jsDownload.startDownload) {
        const downloadUrl = `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=11509`;
        const status = jsDownload.getDownloadStatus({ url: downloadUrl });
        const toast = get(window, 'browser.app.toast');
        if (status === 'TASK_STATUS_NONE') {
          jsDownload.startDownload({
            url: downloadUrl,
            filename: 'QQ浏览器.apk',
            needdialog: 'false',
            neednotification: 'true',
            needtoast: 'false'
          });
          toast && toast('已加入任务，请等待安装~');
        } else if (status === 'TASK_STATUS_COMPLETED') {
          jsDownload.installApp({
            url: downloadUrl,
            checkpolicy: 2
          });
        } else if (status === 'TASK_STATUS_PROGRESS') {
          toast && toast('还在下载中，请等待安装~');
        }
      }
    }

  }
}